// src/redux/commonsharing/locationSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// 🔄 Async Thunk with geolocation OR postal code search
export const fetchGeoLocation = createAsyncThunk(
  'location/fetchGeoLocation',
  async (postalCode = null, { rejectWithValue }) => {
    try {
      let latitude, longitude;
      let address = null;

      if (postalCode) {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?postalcode=${postalCode}&format=json&addressdetails=1`
        );
        const results = await response.json();

        if (!results || results.length === 0) {
          throw new Error('No results found for given postal code.');
        }

        latitude = results[0].lat;
        longitude = results[0].lon;
        address = results[0].address;
      } else {
        if (!navigator.geolocation) {
          return rejectWithValue('Geolocation is not supported by your browser.');
        }

        const getPosition = () =>
          new Promise((resolve, reject) =>
            navigator.geolocation.getCurrentPosition(resolve, reject)
          );

        const position = await getPosition();
        latitude = position.coords.latitude;
        longitude = position.coords.longitude;

        const reverseRes = await fetch(
          `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
        );
        const reverseData = await reverseRes.json();

        address = reverseData.address;
      }

      const now = new Date();
      const date = now.toISOString().split('T')[0];
      const time = now.toTimeString().split(' ')[0];

      let locationDetails = {
        village: address.village || '',
        city: address.county || address.city || address.town || address.district || '',
        residential: address.residential || '',
        stateDistrict: address.state_district || '',
        state: address.state || '',
        country: address.country || '',
        postalCode: address.postcode || postalCode || '',
        isoCode: address['ISO3166-2-lvl4'] || '',
       
        date,
        time,
      };
      console.log('📍 Final Location Details:', locationDetails);


      // Remove empty fields
      locationDetails = Object.fromEntries(
        Object.entries(locationDetails).filter(([_, v]) => v !== '')
      );

      console.log('📍 Final Location Details:', locationDetails);
      return locationDetails;
    } catch (error) {
      console.error('❌ Location Fetch Error:', error);
      return rejectWithValue(error.message || 'Failed to fetch location.');
    }
  }
);

// 📦 Slice with initial state
const locationSlice = createSlice({
  name: 'location',
  initialState: {
    data: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGeoLocation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGeoLocation.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchGeoLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch location.';
      });
  },
});

export default locationSlice.reducer;
